import React from "react";

import { visibilityStore } from "./store/VisibilityStore";
import { Container } from "../Container";
import { VisibilityMarkenPublic, IProps } from "./VisibilityMarkenPublic";

export const VisibilityMarkenPublicWidget = (props: IProps): JSX.Element => (
	<Container store={visibilityStore}>
		<VisibilityMarkenPublic {...props} />
	</Container>
);
